<template>
  <StepWrapper :step-number="2" header-text="Set Design Size">
    <ArtworkMultiDimensions
      :artwork="artwork"
      :index="index"
      :disabled="disabled"
      :readonly="readonly"
      :show-free-transfers-badge="showFreeTransfersBadge"
    />
    <PreCut v-if="withPreCut" />
    <UploadBox v-if="showMultiUploadBox" @upload="handleShowFileDialog" />
  </StepWrapper>
</template>

<script>
import ArtworkMultiDimensions from "./ArtworkMultiDimensions.vue";
import StepWrapper from "../common/StepWrapper.vue";
import PreCut from "../PreCut.vue";
import UploadBox from "../UploadBox.vue";

export default {
  name: "MultiSizeStep",
  components: {
    ArtworkMultiDimensions,
    StepWrapper,
    PreCut,
    UploadBox
  },
  props: {
    artwork: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    withPreCut: {
      type: Boolean,
      default: false
    },
    showMultiUploadBox: {
      type: Boolean,
      default: false
    },
    showFileDialog: {
      type: Function,
      default: null
    },
    showFreeTransfersBadge: {
      type: Boolean,
      default: false
    }
  },
  emits: ["showFileDialog"],
  methods: {
    handleShowFileDialog(data) {
      this.$emit("showFileDialog", data);
    }
  }
};
</script>
